import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import MaskedInput from 'react-maskedinput';
import { Card, Checkbox, Dropdown, Form, Input, Image, Grid } from 'semantic-ui-react';

import TargetLink from '../target-link';

const genderOptions = [
    { text: 'Male', value: 'male' },
    { text: 'Female', value: 'female' },
    { text: 'Other', value: 'other' },
];

const BlogosphereDetails = props => {
  const { details } = props;
  const {
    ethnicity,
    dob,
    gender,
    camera,
    phone,
    photoLink,
    mediaKitLink,
    blogosphereSubscriber,
  } = details;
  const isBlogosphereSubscibed = _.lowerCase(blogosphereSubscriber) === 'yes';
  return (
    <Card fluid>
      <Card.Content>
        <Card.Header>
              Blogosphere Details
        </Card.Header>
      </Card.Content>
      <Card.Content>
        <Form>
          <Grid verticalAlign="middle">

            <Grid.Row>
              <Grid.Column width={4}>
                  Date of birth
                </Grid.Column>
              <Grid.Column width={12}>
                <MaskedInput mask="1111-11-11" name="card" size="20" value={dob} />
              </Grid.Column>
            </Grid.Row>

            <Grid.Row>
              <Grid.Column width={4}>
                  Gender
                </Grid.Column>
              <Grid.Column width={12}>
                <Dropdown placeholder="Select gender" value={_.lowerCase(gender)} fluid selection options={genderOptions} />
              </Grid.Column>
            </Grid.Row>

            <Grid.Row>
              <Grid.Column width={4}>
                  Ethnicity
                </Grid.Column>
              <Grid.Column width={12}>
                <Input fluid placeholder="British" value={ethnicity} />
              </Grid.Column>
            </Grid.Row>

            <Grid.Row>
              <Grid.Column width={4}>
                  Camera
                </Grid.Column>
              <Grid.Column width={12}>
                <Input fluid placeholder="Canon EOS" value={camera} />
              </Grid.Column>
            </Grid.Row>

            <Grid.Row>
              <Grid.Column width={4}>
                  Phone
                </Grid.Column>
              <Grid.Column width={12}>
                <Input fluid placeholder="Apple iPhone X" value={phone} />
              </Grid.Column>
            </Grid.Row>

            <Grid.Row>
              <Grid.Column width={4}>
                  Subscribed to blogosphere?
                </Grid.Column>
              <Grid.Column width={12}>
                <Checkbox label="Yes" checked={isBlogosphereSubscibed} />
              </Grid.Column>
            </Grid.Row>

            <Grid.Row>
              <Grid.Column width={4}>
                Blogosphere Pic
              </Grid.Column>
              <Grid.Column width={12}>
                <Image size="small" src={photoLink} />
              </Grid.Column>
            </Grid.Row>

            <Grid.Row>
              <Grid.Column width={4}>
                Download media kit
              </Grid.Column>
              <Grid.Column width={12}>
                <TargetLink renderIf href={mediaKitLink}>Media kit link</TargetLink>
              </Grid.Column>
            </Grid.Row>

          </Grid>
        </Form>
      </Card.Content>
    </Card>
  );
};

BlogosphereDetails.propTypes = {
  details: PropTypes.object.isRequired,
};

export default BlogosphereDetails;



/** WEBPACK FOOTER **
 ** ./src/components/blogosphere-details/index.js
 **/